import byDefault from "./default";

let labels = null;
let defaultLabels = null;
let labelsInitialized = false;
let labelLoaded = false;

// Initialize labels synchronously
function initLabels() {
  if (!labelsInitialized) {
    // Set default labels as a fallback
    labels = byDefault;
    defaultLabels = byDefault;
    labelsInitialized = true;

    // Try to load subdomain-specific labels
    if (window.subdomain) {
      try {
        // Use require instead of import for synchronous loading
        // This creates a separate bundle for each label file but ensures it's loaded synchronously
        const labelModule = require(`./${window.subdomain}`).default;
        if (labelModule) {
          labels = labelModule;
          labelLoaded = true;
        }
      } catch (error) {
        // If require fails, try dynamic import as a fallback
        if (!labelLoaded) {
          import(`./${window.subdomain}`)
            .then((module) => {
              if (module && module.default) {
                labels = module.default;
                labelLoaded = true;
              }
            })
            .catch((err) => {
              console.warn(
                `Could not load labels for subdomain: ${window.subdomain}, using default`,
                err
              );
            });
        }
      }
    }
  }
}

// Initialize labels on import
initLabels();

const getLabel = (key, defaultValue) => {
  // Ensure labels are initialized
  if (!labelsInitialized) {
    initLabels();
  }

  let returnValue;

  try {
    if (labels && labels.en && labels.en[key] !== undefined) {
      returnValue = labels.en[key];
    }
    else if (labels && labels[key] !== undefined) {
      returnValue = labels[key];
    }
    else if (defaultLabels && defaultLabels.en && defaultLabels.en[key] !== undefined) {
      returnValue = defaultLabels.en[key];
    } else if (defaultLabels && defaultLabels[key] !== undefined) {
      returnValue = defaultLabels[key];
    }
  } catch (error) {
    console.warn(`Error getting label for key: ${key}`, error);
  }
  return returnValue!==undefined ? returnValue : defaultValue!==undefined ? defaultValue : key;
};

const Labels = {
  getLabel,
};

export default Labels;
